"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROCESS_CHECKOUT = void 0;
var graphql_tag_1 = __importDefault(require("graphql-tag"));
var react_apollo_1 = require("react-apollo");
exports.PROCESS_CHECKOUT = (0, graphql_tag_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation ProcessCheckout($token: String!, $paymentToken: String!, $paymentProcessor: PaymentProcessor, $acceptsMarketing: Boolean, $paymentType: PaymentType) {\n    processCheckout(token: $token, paymentToken: $paymentToken, paymentProcessor: $paymentProcessor, acceptsMarketing: $acceptsMarketing, paymentType: $paymentType) {\n      authorization_token\n      payment_processor_transaction_id\n      charge_id\n      payment_processor\n      payment_token\n      payment_processor_customer_id\n      status\n    }\n  }\n"], ["\n  mutation ProcessCheckout($token: String!, $paymentToken: String!, $paymentProcessor: PaymentProcessor, $acceptsMarketing: Boolean, $paymentType: PaymentType) {\n    processCheckout(token: $token, paymentToken: $paymentToken, paymentProcessor: $paymentProcessor, acceptsMarketing: $acceptsMarketing, paymentType: $paymentType) {\n      authorization_token\n      payment_processor_transaction_id\n      charge_id\n      payment_processor\n      payment_token\n      payment_processor_customer_id\n      status\n    }\n  }\n"])));
var default_1 = /** @class */ (function (_super) {
    __extends(default_1, _super);
    function default_1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return default_1;
}(react_apollo_1.Mutation));
exports.default = default_1;
var templateObject_1;
